// TODO: Move off of tooltip.js that has just been discontinued: https://github.com/popperjs/popper.js#wheres-tooltipjs

import Tooltip from 'tooltip.js';
import { merge } from 'lodash-es';

const DEFAULT_OPTIONS = {
  html: false,
  placement: 'top',
  container: 'body',
  className: '',
  popperOptions: {
    offsets: {},
  },
};

export default function (referenceElement, title, options = {}) {
  // eslint-disable-next-line prototype-pollution-security-rules/detect-merge-objects
  const finalOptions = merge({}, DEFAULT_OPTIONS, options, { title });

  if (!finalOptions.template) {
    const placementClass = finalOptions.placement; // TODO: Adapt top top-left, bottom-right, etc.
    const extraClass = finalOptions.className ? ` ${finalOptions.className}` : '';

    // Forced 0 margin is needed to counter positioning differences between bootstrap/popper
    finalOptions.template = `
    <div class="vue-tooltip ${extraClass} ${placementClass}">
      <div class="tooltip-arrow" style="margin: 0"></div>
      <div class="tooltip-inner"></div>
    </div>`;
  }

  return new Tooltip(referenceElement, finalOptions);
}
